import React, { useState } from 'react';
import { FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <section className="contact-us" id="contact">
      <h2 className="contact-heading">Contact Us</h2>

      <div className="contact-content">
        {/* Contact Info */}
        <div className="contact-info">
          <div className="contact-item">
            <div className="contact-icon">
              <FiPhone size={42} color="#FFC501" />
            </div>
            <div className="contact-details">
              <h3>Call</h3>
              <p>084524145547</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <FiMail size={42} color="#FFC501" />
            </div>
            <div className="contact-details">
              <h3>Email</h3>
              <p className="email-link">sndpyogamuk@gmail.com</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <FiMapPin size={42} color="#FFC501" />
            </div>
            <div className="contact-details">
              <h3>Location</h3>
              <p>ALMONDSBURY CREATIVE<br />10 GLOUCESTER ROAD<br />BRISTOL.BS32 4AA</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <FiClock size={42} color="#FFC501" />
            </div>
            <div className="contact-details">
              <h3>Hours</h3>
              <p>Monday - Saturday<br />9:30 - 11:30am</p>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-field">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-field">
            <input
              type="email"
              name="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-field">
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              required
            />
          </div>

          <button type="submit" className="submit-btn">Send now</button>
        </form>
      </div>
    </section>
  );
};

export default ContactUs;
